import { Star } from "lucide-react";
import { formatPercent, formatPrice, formatQuantity } from "@/lib/format";

const fmt = (v) => formatPrice(v);

export const WatchlistRow = ({ asset, selected, onSelect, onToggleFavorite }) => {
  const up = asset.change_pct >= 0;
  return (
    <button
      onClick={() => onSelect(asset)}
      data-testid={`watchlist-row-${asset.symbol}`}
      className={`w-full border-b border-[#101724] px-4 py-3 text-left transition-colors ${
        selected ? "bg-[#101B2E]" : "hover:bg-[#0D1420]"
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-mono text-sm font-medium text-white">{asset.symbol}</span>
            <span
              role="button"
              tabIndex={0}
              data-testid={`favorite-${asset.symbol}`}
              onClick={(e) => {
                e.stopPropagation();
                onToggleFavorite(asset);
              }}
              onKeyDown={(e) => e.key === "Enter" && onToggleFavorite(asset)}
            >
              <Star
                className={`h-3.5 w-3.5 transition-colors ${
                  asset.favorite ? "fill-[#F59E0B] text-[#F59E0B]" : "text-[#4A5567] hover:text-[#F59E0B]"
                }`}
              />
            </span>
          </div>
          <p className="truncate text-xs text-[#8A97AD]">{asset.name}</p>
          <p className={`mt-1 font-mono text-xs ${up ? "text-[#10B981]" : "text-[#EF4444]"}`}>
            {up ? "▲" : "▼"} {formatPercent(Math.abs(asset.change_pct))}
            <span className="ml-2 text-[#5C6B82]">⇥ {formatQuantity(asset.volume)}</span>
          </p>
        </div>

        <div className="flex shrink-0 gap-6 text-right">
          <div>
            <p className={`font-mono text-sm ${up ? "text-[#10B981]" : "text-[#EF4444]"}`}>{fmt(asset.sell)}</p>
            <p className="font-mono text-[10px] text-[#5C6B82]">L: {fmt(asset.low)}</p>
          </div>
          <div>
            <p className={`font-mono text-sm ${up ? "text-[#10B981]" : "text-[#EF4444]"}`}>{fmt(asset.buy)}</p>
            <p className="font-mono text-[10px] text-[#5C6B82]">H: {fmt(asset.high)}</p>
          </div>
        </div>
      </div>
    </button>
  );
};
